module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('request-status', {
    attrs: {
      "request": _vm.request,
      "message200": false
    },
    on: {
      "ok": function($event) {
        return _vm.$emit('success')
      }
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "py-0 grey lighten-4"
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "small": "",
      "loading": _vm.request.loading
    },
    on: {
      "click": _vm.get
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1), _vm._v("\n    Form settings\n    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('space-picker', {
    attrs: {
      "multiple": "",
      "label": "Which spaces do you want to use this form in?",
      "with-select": false
    },
    model: {
      value: (_vm.spaces),
      callback: function($$v) {
        _vm.spaces = $$v
      },
      expression: "spaces"
    }
  }), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-0"
  }, [(_vm.form && _vm.form.products) ? [(_vm.products.length === 0) ? [_c('span', {
    staticClass: "info--text caption"
  }, [_vm._v("Form is shared on all appointment types")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showproductpicker = true
      }
    }
  }, [_vm._v("edit")])] : [_c('product-chips', {
    staticClass: "my-3",
    attrs: {
      "with-space-name": "",
      "product-ids": _vm.form.products
    },
    on: {
      "selected": function($event) {
        _vm.showproductpicker = true
      }
    }
  }, [_c('template', {
    slot: "before"
  }, [_vm._v("Only shown for: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "slot": "after",
      "small": "",
      "text": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showproductpicker = true
      }
    },
    slot: "after"
  }, [_vm._v("edit")])], 2)], _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.showproductpicker),
      callback: function($$v) {
        _vm.showproductpicker = $$v
      },
      expression: "showproductpicker"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline py-1 grey lighten-4"
  }, [_vm._v("\n            Choose appointment types\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save();
        _vm.showproductpicker = false
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.showproductpicker = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-alert', {
    staticClass: "ma-0 pa-2 caption",
    attrs: {
      "type": "info",
      "tile": "",
      "outlined": "",
      "value": true
    }
  }, [_vm._v("\n            Select products below to only show this form for those specific products\n          ")]), _vm._v(" "), _c('product-tree-picker', {
    attrs: {
      "expanded": "",
      "space-ids": _vm.spaces
    },
    model: {
      value: (_vm.form.products),
      callback: function($$v) {
        _vm.$set(_vm.form, "products", $$v)
      },
      expression: "form.products"
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showproductpicker = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save();
        _vm.showproductpicker = false
      }
    }
  }, [_vm._v("Save and close")])], 1)], 1)], 1)] : _vm._e(), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "persistent-hint": "",
      "label": "Link this form",
      "hint": "Include a link to this form in notifications, on the client appointment information page and in your appointment link page"
    },
    model: {
      value: (_vm.withLink),
      callback: function($$v) {
        _vm.withLink = $$v
      },
      expression: "withLink"
    }
  }), _vm._v(" "), _c('v-textarea', {
    staticClass: "mt-3",
    attrs: {
      "outline": "",
      "persistent-hint": "",
      "label": "Form description",
      "hint": "You can add a description to give the client some context on this form - e.g.: you only need to full in this form for a certain appointment type"
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "display order",
      "hint": "The order in which this form will be displayed to the client"
    },
    model: {
      value: (_vm.form.order),
      callback: function($$v) {
        _vm.$set(_vm.form, "order", $$v)
      },
      expression: "form.order"
    }
  })], 2), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Done")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "loading": _vm.request.loading
    },
    on: {
      "click": function($event) {
        _vm.withClose = true;
        _vm.save()
      }
    }
  }, [_vm._v("Save and close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.request.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55e2fb99","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Integrations/JotForm/FormSettings.vue
// module id = 1660
// module chunks = 0